/**
 * Client-only helpers for Open Belot 1×1 UI (legal moves mirror server engine).
 *
 * @module game/belot/openDuell/openDuellClientLegal
 */

const { legalPlays } = require("../armenian/tricks");
const { virtualPlayableForOpenDuellTurn, topCardsFromTable } = require("./engine");

/**
 * @param {object} p
 * @param {0|1|null} p.mySeat
 * @param {number[]} p.myHand
 * @param {number[][]} p.myTableStacks
 * @param {{ seat: number, card: number }[]} p.currentTrick
 * @param {number|null} p.trickLeadSeat
 * @param {number|null} p.contractTrump — `contract.trumpSuit` (в т.ч. без козыря)
 * @param {number|null} p.currentTurnSeat — логическое место хода (0/1 рука, 2/3 верх столбца)
 * @returns {number[]}
 */
function computeOpenDuellLegalPlayCardIds({
  mySeat,
  myHand,
  myTableStacks,
  currentTrick,
  trickLeadSeat,
  contractTrump,
  currentTurnSeat,
}) {
  if (mySeat !== 0 && mySeat !== 1) return [];
  if (trickLeadSeat == null || !Array.isArray(currentTrick)) return [];
  if (typeof currentTurnSeat !== "number") return [];
  const hand = Array.isArray(myHand) ? myHand : [];
  const tabsRaw = Array.isArray(myTableStacks) ? myTableStacks : [];
  const tabs = tabsRaw.map((col) => (Array.isArray(col) ? col : []));
  const stateLike = {
    hands: mySeat === 0 ? [hand, []] : [[], hand],
    tableStacks: mySeat === 0 ? [tabs, []] : [[], tabs],
  };
  const virtual = virtualPlayableForOpenDuellTurn(stateLike, mySeat, currentTurnSeat);
  const legal = legalPlays(virtual, currentTrick, contractTrump, trickLeadSeat);

  const handTurn = currentTurnSeat === mySeat;
  const tableTurn = currentTurnSeat === mySeat + 2;
  if (handTurn) {
    const inHand = new Set(hand);
    if (hand.length === 0) {
      const tops = new Set(topCardsFromTable(tabs));
      return legal.filter((id) => tops.has(id));
    }
    return legal.filter((id) => inHand.has(id));
  }
  if (tableTurn) {
    const tops = new Set(topCardsFromTable(tabs));
    return legal.filter((id) => tops.has(id));
  }
  return [];
}

module.exports = {
  computeOpenDuellLegalPlayCardIds,
};
